import { LIMIT_PER_PAGE } from "../utils/consts";
import { $authHost, $host } from "./index";

export const createType = async (type) => {
  const { data } = await $authHost.post("api/type", type);
  return data;
};
export const createSubType = async (subType) => {
  const { data } = await $authHost.post('api/type/subtype', subType);
  return data;
};
export const fetchTypes = async () => {
  const { data } = await $host.get("api/type");
  return data;
};

export const createBrand = async (brand) => {
  const { data } = await $authHost.post("api/brand", brand);
  return data;
};

export const fetchBrands = async () => {
  const { data } = await $host.get("api/brand");
  return data;
};

export const createDetail = async (detail) => {
  const { data } = await $authHost.post("api/detail", detail);
  return data;
};

export const fetchDetails = async (
  typeId,
  subTypeId,
  brandId,
  page,
  limit = LIMIT_PER_PAGE,
  searchQuery = ''
) => {
  const params = { typeId, subTypeId, brandId };
  if (searchQuery) {
    params.search = searchQuery;
  } else {
    params.page = page;
    params.limit = limit;
  }

  const { data } = await $host.get('api/detail', { params });
  return data;
};

export const fetchOneDetails = async (id) => {
  const { data } = await $host.get("api/detail/" + id);
  return data;
};